











import { Component, Vue } from 'vue-property-decorator'
import Header from '@/apps/open/layout/Header.vue'
import Footer from '@/apps/open/layout/Footer.vue'
import { detectMob } from '@/apps/open/utils'
import MobileHeader from '@/apps/mobile/Header.vue'

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate'
])

@Component({
  components: {
    'my-header': Header,
    'my-footer': Footer,
    MobileHeader
  }
})
export default class App extends Vue {
  isMobile = false
  companyListInPlus:any = []

  get isHome () {
    return this.$route.name === 'home'
  }

  get isPrivate () {
    return this.$store.getters['isPrivate']
  }

  get showFooter () {
    return !this.$route.path.includes('docs/cloud') &&
      !this.$route.path.includes('docs/wwo') &&
      !this.$route.path.includes('docs/enterprise-inner-app') &&
      !this.$route.path.includes('docs/doc-format-conversion') &&
      !this.isPrivate
  }
}
